import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeatureFlagService } from '@vendasta/businesses';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PartnerService } from '../core/partner.service';

const GET_SEND_AS_INFORMATION_URL = '/api/v3/partner/getSendAsInformation/';

@Injectable({ providedIn: 'root' })
export class CampaignSettingsService {
  public pendingDomainFeatureEnabled$: Observable<boolean>;

  constructor(
    private http: HttpClient,
    private partnerService: PartnerService,
    private featureFlagService: FeatureFlagService,
  ) {
    this.pendingDomainFeatureEnabled$ = this.featureFlagService.checkFeatureFlag(
      this.partnerService.partnerId,
      '',
      'pending_email_domain',
    );
  }

  public getSendAsInformation(partnerId: string): Observable<GetEmailSendAsResponse> {
    return this.http
      .get(GET_SEND_AS_INFORMATION_URL, {
        withCredentials: true,
        params: {
          partnerId: partnerId,
        },
      })
      .pipe(
        map((response: any) => {
          return {
            sendAsName: response.data.sendAsName,
            sendAsEmailAddress: response.data.sendAsEmailAddress,
            replyToEmailAddress: response.data.replyToEmailAddress,
          };
        }),
      );
  }
}

export interface GetEmailSendAsResponse {
  sendAsEmailAddress: string;
  replyToEmailAddress: string;
  sendAsName: string;
}
